// extracted by mini-css-extract-plugin
export default {"container":"Cp-z","brandName":"Dp-z","productName":"Ep-z","productNamePdpEnhancements":"Fp-z","breakLongProductName":"Gp-z"};